import React from 'react';
import QuestionForm from '../QuestionForm';

const QuestionNew = () => {
  return <QuestionForm title="Crear Pregunta" submitText="Crear" />;
};

export default QuestionNew;
